export const MODULI_ENTERPRISE = {
    NumUtenti: 0,
    LicNonRivend: false,
    MagDoc: {
        DocMag: false,
        Commesse: false,
        Lotti: false,
        Rapportini: false
    },
    DistBase: {
        DistintaBase: false,
        Produzione: false,
        RilTempi: false
    },
    Contabilita: {
        Contab: false,
        Analitica: false,
        Cespiti: false,
        SintesiDati: false,
        ModuloFiscale: false,
        Gold: false
    },
    Generali: {
        DocumentiDigitali: false,
        PostaElettronica: false,
        EasyCRM: false,
        Cruscotto: false,
        ECommerce: false,
        MultiLingua: false,
        RilevPres: false,
        Dashboard: false,
        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        VisionPivot: false,
        VisionDataView: false,
        VisionProduce: false,
        VisionDocumatic: false,
        VisionCatalogo: false,
        VisionSms: false,
        VisionVortal: false,
        VisionMobile: false,
        VisionAssist: false,
        VisionOffline: false,
        VisionRetail: false,

        FEBase: false,
        FeFull: false,
        DMS: false,
    },
    Verticali: {
        FreshGross: false,
        FreshMerc: false,
        EnergyBase: false,
        EnerSerb: false,
        EnerCana: false,
        EnerPratiche: false,
        EnerTVNotebook: false,
        EnerTVPalm: false,
        Cant: false,
        Pref: false,
        Sisma: false,
        Trasporti: false,
    }
};

export const MODULI_ERP = {
    NumUtenti: 0,
    LicNonRivend: false,
    MagDoc: {
        DocMag: false,
        Commesse: false,
        Lotti: false,
        Rapportini: false
    },
    DistBase: {
        DistintaBase: false,
        Produzione: false
    },
    Contabilita: {
        Contab: false,
        Analitica: false,
        Cespiti: false,
        SintesiDati: false,
        ModuloFiscale: false
    },
    Generali: {
        DocumentiDigitali: false,
        PostaElettronica: false,
        EasyCRM: false,
        Cruscotto: false,
        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        ECommerce: false,
        MultiLingua: false,
        VisionRetail: false,
        VisionOffline: false,
        VisionCatalogo: false,
        VisionDocumatic: false,
        VisionSms: false,
        VisionPivot: false,
        VisionDataView: false,
        ContributiAmbientali: false
    }
};




// Profili predefiniti per tipologia Enterprise
export const ULTIMATE = {
    NumUtenti: 2,
    LicNonRivend: true,
    MagDoc: {
        DocMag: true,
        Commesse: true,
        Lotti: true,
        Rapportini: true
    },
    DistBase: {
        DistintaBase: true,
        Produzione: true,
        RilTempi: true
    },
    Contabilita: {
        Contab: true,
        Analitica: true,
        Cespiti: true,
        SintesiDati: true,
        ModuloFiscale: false,
        Gold: false
    },
    Generali: {
        DocumentiDigitali: true,
        PostaElettronica: true,
        EasyCRM: true,
        Cruscotto: true,
        ECommerce: false,
        MultiLingua: true,
        RilevPres: true,
        Dashboard: false,

        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        VisionPivot: true,
        VisionDataView: false,
        VisionProduce: false,
        VisionDocumatic: false,

        VisionCatalogo: false,
        VisionSms: false,
        VisionVortal: false,
        VisionMobile: false,
        VisionAssist: false,
        VisionOffline: false,
        VisionRetail: true,

        FEBase: false,
        FeFull: false,
        DMS: false,
    },
    Verticali: {
        FreshGross: false,
        FreshMerc: false,
        EnergyBase: false,
        EnerSerb: false,
        EnerCana: false,
        EnerPratiche: false,
        EnerTVNotebook: false,
        EnerTVPalm: false,
        Cant: false,
        Pref: false,
        Sisma: false,
        Trasporti: false,
    }
};

export const BUSINESS = {
    NumUtenti: 2,
    LicNonRivend: true,
    MagDoc: {
        DocMag: true,
        Commesse: true,
        Lotti: true,
        Rapportini: true
    },
    DistBase: {
        DistintaBase: true,
        Produzione: false,
        RilTempi: false
    },
    Contabilita: {
        Contab: true,
        Analitica: false,
        Cespiti: true,
        SintesiDati: true,
        ModuloFiscale: false,
        Gold: false
    },
    Generali: {
        DocumentiDigitali: true,
        PostaElettronica: true,
        EasyCRM: true,
        Cruscotto: true,
        ECommerce: false,
        MultiLingua: true,
        RilevPres: true,
        Dashboard: false,

        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        VisionPivot: true,
        VisionDataView: false,
        VisionProduce: false,
        VisionDocumatic: false,

        VisionCatalogo: false,
        VisionSms: false,
        VisionVortal: false,
        VisionMobile: false,
        VisionAssist: false,
        VisionOffline: false,
        VisionRetail: true,

        FEBase: false,
        FeFull: false,
        DMS: false,
    },
    Verticali: {
        FreshGross: false,
        FreshMerc: false,
        EnergyBase: false,
        EnerSerb: false,
        EnerCana: false,
        EnerPratiche: false,
        EnerTVNotebook: false,
        EnerTVPalm: false,
        Cant: false,
        Pref: false,
        Sisma: false,
        Trasporti: false,
    }
};

export const STANDARD = {
    NumUtenti: 2,
    LicNonRivend: true,
    MagDoc: {
        DocMag: true,
        Commesse: false,
        Lotti: true,
        Rapportini: false
    },
    DistBase: {
        DistintaBase: false,
        Produzione: false,
        RilTempi: false
    },
    Contabilita: {
        Contab: true,
        Analitica: false,
        Cespiti: true,
        SintesiDati: true,
        ModuloFiscale: false,
        Gold: false
    },
    Generali: {
        DocumentiDigitali: true,
        PostaElettronica: true,
        EasyCRM: false,
        Cruscotto: false,
        ECommerce: false,
        MultiLingua: true,
        RilevPres: false,
        Dashboard: false,

        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        VisionPivot: false,
        VisionDataView: false,
        VisionProduce: false,
        VisionDocumatic: false,

        VisionCatalogo: false,
        VisionSms: false,
        VisionVortal: false,
        VisionMobile: false,
        VisionAssist: false,
        VisionOffline: false,
        VisionRetail: false,

        FEBase: false,
        FeFull: false,
        DMS: false,
    },
    Verticali: {
        FreshGross: false,
        FreshMerc: false,
        EnergyBase: false,
        EnerSerb: false,
        EnerCana: false,
        EnerPratiche: false,
        EnerTVNotebook: false,
        EnerTVPalm: false,
        Cant: false,
        Pref: false,
        Sisma: false,
        Trasporti: false,
    }
};

export const SMALL_BUSINESS = {
    NumUtenti: 3,
    LicNonRivend: true,
    MagDoc: {
        DocMag: true,
        Commesse: false,
        Lotti: true,
        Rapportini: true
    },
    DistBase: {
        DistintaBase: true,
        Produzione: false,
        RilTempi: false
    },
    Contabilita: {
        Contab: true,
        Analitica: false,
        Cespiti: false,
        SintesiDati: false,
        ModuloFiscale: false,
        Gold: false
    },
    Generali: {
        DocumentiDigitali: true,
        PostaElettronica: true,
        EasyCRM: false,
        Cruscotto: false,
        ECommerce: false,
        MultiLingua: true,
        RilevPres: false,

        Dashboard: false,
        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        VisionPivot: false,
        VisionDataView: false,
        VisionProduce: false,
        VisionDocumatic: false,

        VisionCatalogo: false,
        VisionSms: false,
        VisionVortal: false,
        VisionMobile: false,
        VisionAssist: false,
        VisionOffline: false,
        VisionRetail: false,

        FEBase: false,
        FeFull: false,
        DMS: false,
    },
    Verticali: {
        FreshGross: false,
        FreshMerc: false,
        EnergyBase: false,
        EnerSerb: false,
        EnerCana: false,
        EnerPratiche: false,
        EnerTVNotebook: false,
        EnerTVPalm: false,
        Cant: false,
        Pref: false,
        Sisma: false,
        Trasporti: false,
    }
};

export const MINI_BUSINESS = {
    NumUtenti: 2,
    LicNonRivend: true,
    MagDoc: {
        DocMag: true,
        Commesse: false,
        Lotti: true,
        Rapportini: false
    },
    DistBase: {
        DistintaBase: false,
        Produzione: false,
        RilTempi: false
    },
    Contabilita: {
        Contab: false,
        Analitica: false,
        Cespiti: false,
        SintesiDati: false,
        ModuloFiscale: false,
        Gold: false
    },
    Generali: {
        DocumentiDigitali: true,
        PostaElettronica: true,
        EasyCRM: false,
        Cruscotto: false,
        ECommerce: false,
        MultiLingua: true,
        RilevPres: false,

        Dashboard: false,
        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        VisionPivot: false,
        VisionDataView: false,
        VisionProduce: false,
        VisionDocumatic: false,

        VisionCatalogo: false,
        VisionSms: false,
        VisionVortal: false,
        VisionMobile: false,
        VisionAssist: false,
        VisionOffline: false,
        VisionRetail: false,

        FEBase: false,
        FeFull: false,
        DMS: false,
    },
    Verticali: {
        FreshGross: false,
        FreshMerc: false,
        EnergyBase: false,
        EnerSerb: false,
        EnerCana: false,
        EnerPratiche: false,
        EnerTVNotebook: false,
        EnerTVPalm: false,
        Cant: false,
        Pref: false,
        Sisma: false,
        Trasporti: false,
    }
};

export const PERSONAL_EDITION = {
    NumUtenti: 1,
    LicNonRivend: true,
    MagDoc: {
        DocMag: true,
        Commesse: false,
        Lotti: true,
        Rapportini: false
    },
    DistBase: {
        DistintaBase: false,
        Produzione: false,
        RilTempi: false
    },
    Contabilita: {
        Contab: true,
        Analitica: false,
        Cespiti: false,
        SintesiDati: false,
        ModuloFiscale: false,
        Gold: false
    },
    Generali: {
        DocumentiDigitali: true,
        PostaElettronica: true,
        EasyCRM: false,
        Cruscotto: false,
        ECommerce: false,
        MultiLingua: true,
        RilevPres: false,

        Dashboard: false,
        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        VisionPivot: false,
        VisionDataView: false,
        VisionProduce: false,
        VisionDocumatic: false,

        VisionCatalogo: false,
        VisionSms: false,
        VisionVortal: false,
        VisionMobile: false,
        VisionAssist: false,
        VisionOffline: false,
        VisionRetail: false,

        FEBase: false,
        FeFull: false,
        DMS: false,
    },
    Verticali: {
        FreshGross: false,
        FreshMerc: false,
        EnergyBase: false,
        EnerSerb: false,
        EnerCana: false,
        EnerPratiche: false,
        EnerTVNotebook: false,
        EnerTVPalm: false,
        Cant: false,
        Pref: false,
        Sisma: false,
        Trasporti: false,
    }
};

export const LITE_EDITION = {
    NumUtenti: 1,
    LicNonRivend: true,
    MagDoc: {
        DocMag: true,
        Commesse: false,
        Lotti: true,
        Rapportini: false
    },
    DistBase: {
        DistintaBase: false,
        Produzione: false,
        RilTempi: false
    },
    Contabilita: {
        Contab: false,
        Analitica: false,
        Cespiti: false,
        SintesiDati: false,
        ModuloFiscale: false,
        Gold: false
    },
    Generali: {
        DocumentiDigitali: false,
        PostaElettronica: true,
        EasyCRM: false,
        Cruscotto: false,
        ECommerce: false,
        MultiLingua: true,
        RilevPres: false,

        Dashboard: false,
        BeniImmob: false,
        Documenti: false,
        Bartolini: false,
        VisionPivot: false,
        VisionDataView: false,
        VisionProduce: false,
        VisionDocumatic: false,

        VisionCatalogo: false,
        VisionSms: false,
        VisionVortal: false,
        VisionMobile: false,
        VisionAssist: false,
        VisionOffline: false,
        VisionRetail: false,

        FEBase: false,
        FeFull: false,
        DMS: false,
    },
    Verticali: {
        FreshGross: false,
        FreshMerc: false,
        EnergyBase: false,
        EnerSerb: false,
        EnerCana: false,
        EnerPratiche: false,
        EnerTVNotebook: false,
        EnerTVPalm: false,
        Cant: false,
        Pref: false,
        Sisma: false,
        Trasporti: false,
    }
};


// in base al keyname dei moduli DocMag ritorna il nome completo da visualizzare
export const formatDocMag = (keyName) => {
    switch(keyName){
        case 'DocMag': return 'Documenti/Magazzino';

        default:
            return keyName;
    }
}

// in base al keyname dei moduli DistBase ritorna il nome completo da visualizzare
export const formatDistBase = (keyName) => {
    switch(keyName){
        case 'DistintaBase': return 'Distinta Base';
        case 'RilTempi': return 'Rilevazione Tempi';

        default:
            return keyName;
    }
}

// in base al keyname dei moduli Contabilita ritorna il nome completo da visualizzare
export const formatContabilita = (keyName) => {
    switch(keyName){
        case 'Contab': return 'Contabilità';
        case 'SintesiDati': return 'Sintesi Dati';
        case 'ModuloFiscale': return 'Modulo Fiscale';

        default:
            return keyName;
    }
}

// in base al keyname dei moduli Generali ritorna il nome completo da visualizzare
export const formatGenerali = (keyName) => {
    switch(keyName){
        case 'DocumentiDigitali': return 'Documenti Digitali';
        case 'PostaElettronica': return 'Posta Elettronica';
        case 'EasyCRM': return 'Easy CRM';
        case 'ECommerce': return 'E-Commerce';
        case 'RilevPres': return 'Rilevazione Presenze';
        case 'BeniImmob': return 'Beni Immobiliari';
        case 'VisionPivot': return 'Vision Pivot';
        case 'VisionDataView': return 'Vision DataView';
        case 'VisionProduce': return 'Vision Produce';
        case 'VisionDocumatic': return 'Vision Documatic';
        case 'FEBase': return 'FE Base';
        case 'VisionCatalogo': return 'Vision Catalogo';
        case 'VisionSMS': return 'Vision SMS';
        case 'VisionAssist': return 'Vision Assist';
        case 'VisionOffline': return 'Vision Offline';
        case 'VisionRetail': return 'Vision Retail';
        case 'FeFull': return 'FE Full';

        case 'ContributiAmbientali': return 'Contributi Ambientali';

        default:
            return keyName;
    }
}


// in base al keyname dei moduli Verticali ritorna il nome completo da visualizzare
export const formatVerticali = (keyName) => {
    switch (keyName) {
        case 'FreshGross': return 'Fresh Grossisti';
        case 'FreshMerc': return 'Fresh Mercati';
        case 'EnergyBase': return 'Energy Base';
        case 'EnerSerb': return 'Energy Serbatoi';
        case 'EnerCana': return 'Energy Canalizzazioni';
        case 'EnerPratiche': return 'Energy Pratiche';
        case 'EnerTVNotebook': return 'Energy TentVend Notebook';
        case 'EnerTVPalm': return 'Energy TentVend Palmari';
        //case 'Cant': return 'Cant';
        //case 'Pref': return 'Pref';
        //case 'Sisma': return 'Sisma';
        //case 'Trasporti': return 'Trasporti';

        default:
            return keyName;
    }
}

